import config from '../config.js'

export class QueryParam {
  constructor(name, value) {
    this.name = name
    this.value = value
  }
}

export function urlify(stringToChange) {
  let stringUrl = stringToChange.toLowerCase()

  // Replace underscores with spaces
  stringUrl = stringUrl.replace(/_/g, ' ')

  // Replace "&" with "and"
  stringUrl = stringUrl.replace(/&/g, 'and')

  // Strip out most punctuation
  // "." is intentionally omitted so that DVO.COM looks ok
  stringUrl = stringUrl.replace(/[`~!#$%^*()+=[\]{}\\|;:’'",<>/?]/g, '')

  // Cure for multiple spaces and hyphens
  stringUrl = stringUrl.replace(/\s+/g, '-')
  stringUrl = stringUrl.replace(/-+/g, '-')

  return stringUrl
}

export function getQueryVariable(variable, queryString) {
  let query = queryString.substring(1)
  let params = query.split('&')

  for (var i = 0; i < params.length; i++) {
    let pair = params[i].split('=')

    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

// Given a recipe ID, create the recipe's path so we can point a link to it
export function getRecipePathById(recipeId) {
  const path = config.baseUrl + '/recipes/' + recipeId

  return path
}

/**
 * Builds a url from the given base url and QueryParams.
 *
 * @param base The base url.
 * @param params A list of QueryParam objects.
 * @returns {string} The built url.
 */
export function buildUrl(base, params) {
  let query = ""
  if (params && params.length > 0) {
    let paramStrings = []
    for (let i = 0; i < params.length; i++) {
      const param = params[i]
      if (param.value) {
        // Param has valid value, so add it to query
        const paramStr = param.name + "=" + param.value
        paramStrings.push(paramStr)
      }
    }
    for (let i = 0; i < paramStrings.length; i++) {
      const paramStr = paramStrings[i]
      if (i === 0) {
        query += "?"
      } else {
        query += "&"
      }
      query += paramStr
    }
  }
  const url = base + query
  return url
}


// WEBPACK FOOTER //
// ./src/Helpers/urls.js